import React, { useEffect, useState } from 'react'
import DynamicForm, { IBaseDynamicFormElement } from '../Form/DynamicForm'
import { useDispatch } from 'react-redux'
import { Autocomplete, IconButton, InputAdornment, TextField } from "@mui/material";
import { error } from 'console';
import { handleRequestError } from '../../services/api';
import { IAxiosDefaultDataObject } from '../../config';
import BasicModalWindow from '../BasicModalWIndow';
import BaseApp, { ISearchParam } from '../../features/BaseApp';
import AdminDynamicCreateOrUpdatePage from '../../features/admin/AdminDynamicCreateOrUpdatePage';
import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import GenerateIcon from '../GenerateIcon';

export interface IDynamicSelectOption {
    label: string;
    value: string;
}

export default function DynamicSelect(props: IBaseDynamicFormElement) {

    const { id, label, fullWidth, data, addNewItem, updateItem, addNoneItem, searchParams, filterBy } = props

    const appClass = props.appClass ? props.appClass : new BaseApp()

    const [newModalStatus, setNewModalStatus] = useState<boolean>(false)

    const [searchParamsList, setSearchParamsList] = useState<ISearchParam[]>(searchParams ? searchParams : [])

    const [selectedOption, setSelectedOption] = useState<IDynamicSelectOption | null>(null);
    const [loading, setLoading] = useState<boolean>(true)

    const itemsList = props.itemsList ? props.itemsList() : []

    const dispatch = useDispatch()

    const [options, setOptions] = useState<IDynamicSelectOption[]>([])

    const modelTitleParam: string = props.modelTitleParam ? props.modelTitleParam : "title"

    const elementsData = DynamicForm.useReturnAllFormsData()
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(name, elementsData).value

    // useEffect(() => {
    //     setSelectedOption(data.value)
    // }, [data])

    const handleChange = (event: React.SyntheticEvent, newValue: IDynamicSelectOption | null) => {

        if (addNoneItem){
            if (newValue === null){
                newValue = {
                     label: "None",
                    value: ""
                }
            }
        }

        setSelectedOption(newValue)
        props.handleOnChange(id, newValue?.value)
    };

    const handleCloseNewModal = () => setNewModalStatus(false)

    /**
     * After add new
     */
    const handleAfterAddNew = () => {
        handleCloseNewModal()
    }

    /**
     * Update options
     */
    useEffect(() => {

        let newOptions: IDynamicSelectOption[] = []

        if (addNoneItem){
            newOptions.push({
                label: "None",
                value: ""
            })
        }

        
        if (itemsList && itemsList.length === 0){
            if (appClass){
                setLoading(true)
                appClass.listOfInstances(1, "", true, false, searchParamsList)
                    .then(response => {

                        const result = response.data
                    
                        if (addNewItem){
                            if (result.length > 0){
                                result.map((item: IAxiosDefaultDataObject) => dispatch(addNewItem(item)))
                            }
                        }

                        setLoading(false)

                    })
                    .catch(error => {
                        handleRequestError(error, dispatch)
                        setLoading(false)
                    })
            }
        }
        // if (appClass){
        //     setLoading(true)
        //     appClass.listOfInstances(1, "", true, false, searchParamsList)
        //         .then(response => {

        //             const result = response.data
                
        //             if (addNewItem){
        //                 if (result.length > 0){
        //                     result.map((item: IAxiosDefaultDataObject) => dispatch(addNewItem(item)))
        //                 }
        //             }

        //             setLoading(false)

        //         })
        //         .catch(error => {
        //             handleRequestError(error, dispatch)
        //             setLoading(false)
        //         })
        // }

        if (itemsList){
            itemsList.map((item) => {
                newOptions.push({
                    label: item[modelTitleParam],
                    value: item.id
                })
            })
        }

        setOptions(newOptions)
        setLoading(false)

    }, [itemsList])

    /**
     * Udpate selected
     */
    useEffect(() => {
        if (options.length > 0){
            options.map((option) => {
                if (option.value == data.value){
                    setSelectedOption(option)
                }
            })
        }
    }, [options])

    useEffect(() => {
        if (filterBy){
            setSearchParamsList([
                {
                    name: filterBy,
                    value: singleElemDataValue(filterBy).value
                }
            ])
        }
    }, [filterBy, singleElemDataValue(filterBy ? filterBy : "")])

    /**
     * Update item
     */
    const handleUpdateItem = (item: IAxiosDefaultDataObject, dispatch: Dispatch<UnknownAction>) => {
        if (addNewItem){
            dispatch(addNewItem(item))
        }
    }

    return(
        <>  
            <BasicModalWindow 
                title={appClass.messages.create}
                showHeader={true}
                shown={newModalStatus} 
                handleClose={handleCloseNewModal} 
                size="md" 
                actionButtons={[
                    {
                        label: "Close",
                        handleClose: true
                    }
                ]}
            >
                {addNewItem && <AdminDynamicCreateOrUpdatePage customPageType="new" noRedirect={true} afterSuccess={handleAfterAddNew} forceCreatePage={true} hidePageHeadBox={true} customPageName={appClass.appName} updateItem={handleUpdateItem} />}
            </BasicModalWindow>
            <Autocomplete
                options={options}
                getOptionLabel={(option) => option.label} // Display label in dropdown
                onChange={handleChange}
                renderInput={(params) => <TextField {...params} label={label} variant="outlined" InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                            <IconButton onClick={() => setNewModalStatus(true)}><GenerateIcon icon="new" /></IconButton>
                      </InputAdornment>
                    ),
                  }} />}
                isOptionEqualToValue={(option, value) => option.value === value?.value} // Ensure proper comparison
                value={selectedOption}
            />
        </>
    )
}